import { render, staticRenderFns } from "./ResponseForm.vue?vue&type=template&id=cf131f32&scoped=true&"
import script from "./ResponseForm.vue?vue&type=script&lang=js&"
export * from "./ResponseForm.vue?vue&type=script&lang=js&"
import style0 from "./ResponseForm.vue?vue&type=style&index=0&id=cf131f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf131f32",
  null
  
)

export default component.exports